const fillWithZeros = (value) => {
  if (typeof value !== "string") return value.toString().padStart(2, "0");
  else return value.padStart(2, "0");
};

const formatDate = ({ date, separator = "/", format = "dd/mm/yyyy" }) => {
  if (!date) return "";

  const order = format.split(separator);
  const dateFormat = new Date(date);

  const year = fillWithZeros(dateFormat.getFullYear());
  const month = fillWithZeros(dateFormat.getMonth() + 1);
  const day = fillWithZeros(dateFormat.getDate());

  const result = [];
  result[order.indexOf("dd")] = day;
  result[order.indexOf("mm")] = month;
  result[order.indexOf("yyyy")] = year;

  return `${result[0]}${separator}${result[1]}${separator}${result[2]}`;
};

const formatDateGetTime = ({
  date,
  separator = "/",
  format = "dd/mm/yyyy",
}) => {
  if (!date) return "";

  const order = format.split(separator);

  const dateFormat = new Date(date);

  const year = fillWithZeros(dateFormat.getFullYear());
  const month = fillWithZeros(dateFormat.getMonth() + 1);
  const day = fillWithZeros(dateFormat.getDate());
  const time =
    fillWithZeros(dateFormat.getHours()) +
    ":" +
    fillWithZeros(dateFormat.getMinutes()) +
    ":" +
    fillWithZeros(dateFormat.getSeconds());

  const result = [];
  result[order.indexOf("dd")] = day;
  result[order.indexOf("mm")] = month;
  result[order.indexOf("yyyy")] = year;
  result[order.indexOf("hh:mm:ss")] = time;

  return `${result[0]}${separator}${result[1]}${separator}${result[2]} ${result[3]}`;
};

const formatDateGetCurrentMonth = ({
  date,
  separator = "/",
  format = "mm/yyyy",
}) => {
  if (!date) return "";

  const order = format.split(separator);
  const dateFormat = new Date(date + "T00:00:00");

  const year = fillWithZeros(dateFormat.getFullYear());
  const month = fillWithZeros(dateFormat.getMonth() + 1);

  const result = [];
  result[order.indexOf("mm")] = month;
  result[order.indexOf("yyyy")] = year;

  return `${result[0]}${separator}${result[1]}`;
};

export { formatDate, formatDateGetTime, formatDateGetCurrentMonth };
